import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { SummaryOptionsStyled } from '../SummaryOptionsStyled';
import { rem } from 'polished';

export const SummaryOptionsStyledAP = styled(SummaryOptionsStyled)`
    &.withBorder {
        border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .optionsWrapper {
        .next-btn,
        .back-btn {
            border: 1px solid;
            border-radius: 0;

            &:not(:disabled) {
                border-color: ${({ theme }) => theme.colors.black};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                background: ${({ theme }) => theme.colors.black};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.white};
                        stroke: ${({ theme }) => theme.colors.black};
                    }
                }
            }
        }
    }
`;
